import { debounce } from '@mui/material';
import dayjs from 'dayjs';

Object.defineProperty(exports, "__esModule", { value: true });
export const ceil = (option, dayjsClass) => {
    dayjsClass.prototype.ceil = function (unit, amount) {
        return this.add(amount - (this.get(unit) % amount), unit).startOf(unit);
    };
};

export const stringToColor = (string) => {
    let hash = 0;
    for (let char in string) {
        hash = string.charCodeAt(char) + ((hash << 5) - hash);
    }
    // Map the hash to an RGB value
    const r = (hash >> 16) & 0xFF;
    const g = (hash >> 8) & 0xFF;
    const b = hash & 0xFF;

    // Return the RGB value as a CSS-compatible string
    return `rgb(${r}, ${g}, ${b})`;
}

export const stringAvatar = (name) => {
    let children = ''
    try {
        children = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
    } catch (error) {
        if (name.length >= 0) {
            children = `${name[0]}`
        }
    }
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: children,
    };
}

export const find_rate_in_group = (rate_group, quantity) => {
    let i = 0
    for (; i < rate_group.length; ++i) {
        if (quantity < rate_group[i].quantity) {
            return rate_group[i - 1]
        }
    }
    return rate_group[i - 1]
}

export const specific_rate_calculation = (rates, hour, quantity = 1) => {
    if (hour < 1) {
        return 0
    }
    const calculated_rates = rate_calculation(rates, hour, quantity)
    return calculated_rates[0][calculated_rates[0].length - 1].cost
}

export const rate_calculation = (rates, hours_checked = 1000, quantity = 1) => {
    let found_issue_with_rates = false
    let editable_rental_rates = JSON.parse(JSON.stringify(rates || []));
    let rental_hours = []
    if (editable_rental_rates.length > 0) {
        editable_rental_rates = editable_rental_rates.map(rate => {
            rate.min_time = rate.min_time * (rate.time_unit === 'h' ? 1 : 24)
            rate.max_time = rate.max_time * (rate.time_unit === 'h' ? 1 : 24)
            return rate
        })
        editable_rental_rates.sort((a, b) => a.min_time < b.min_time)
        editable_rental_rates.slice(1).forEach((rate, index_of_prev) => {
            if (editable_rental_rates[index_of_prev].max_time > rate.min_time) {
                found_issue_with_rates = true
            }
        });
        // Generate visual of charges
        let current_rate_index = 0 // first rate
        for (let i = 1; i <= hours_checked; i++) {
            if (current_rate_index < editable_rental_rates.length - 1 && i > editable_rental_rates[current_rate_index].max_time) {
                current_rate_index += 1
            }
            const current_rate = editable_rental_rates[current_rate_index]
            let time_division = 1
            if (current_rate.time_unit === 'h') {
                time_division = 1
            }
            else if (current_rate.time_unit === 'd') {
                time_division = 24
            }
            const cost = Math.max(Math.ceil(current_rate.min_time / time_division), Math.ceil(i / time_division)) * (current_rate.rate || 0)
            const rate_text = editable_rental_rates[current_rate_index]?.name ?? (current_rate.name + '/DEFAULTED')
            rental_hours.push({ cost: cost * quantity, text: rate_text })
        }
    }
    return [rental_hours, found_issue_with_rates,]
}

export const rate_chunks = (rental_hours) => {
    console.log(rental_hours)
    if (rental_hours.length === 0) {
        return []
    }
    let combined_rental_hours = []
    combined_rental_hours.push({ start: 0, text: `${rental_hours[0].cost} ${rental_hours[0].text}` })
    for (let i = 1; i < rental_hours.length; i++) {
        const rate_text = `${rental_hours[i].cost} ${rental_hours[i].text}`
        if (combined_rental_hours[combined_rental_hours.length - 1].text === rate_text) {
            continue
        } else {
            combined_rental_hours[combined_rental_hours.length - 1].end = i - 1
            combined_rental_hours.push({ start: i, text: rate_text })
        }
    }
    combined_rental_hours[combined_rental_hours.length - 1].end = rental_hours.length - 1

    return combined_rental_hours
}

const rate_visualization_time_format = (time) => {
    let text = ''
    if (time >= 24) {
        text += `${Math.floor(time / 24)}d`
        if (time % 24 !== 0) {
            text += `,${time % 24}h`
        }
    } else {
        text += `${time % 24}h`
    }
    return text
}

export const rate_visualization = (combined_rental_hours, max_rates = 20, marked_hour = false) => {
    return (
        <span style={{ display: 'grid' }}>
            {combined_rental_hours.map((item) => {

                let text = `${rate_visualization_time_format(item.start + 1)} - ${rate_visualization_time_format(item.end + 1)}: $${item.text}`
                if ((item.start + 1) <= marked_hour && marked_hour <= (item.end + 1)) {
                    return (<span><b><u>{text}</u></b></span>)
                }
                else {
                    return (<span>{text}</span>)
                }
            }).slice(0, max_rates)}
        </span>
    )
}

export const updateRentalItemsAvailability = (rentalItem, reserveStartDate, reserveEndDate) => {
    rentalItem.overlapping_reservations = []
    rentalItem.reservation_tooltip = ""
    let my_reservations = rentalItem.rental_contract_items.sort((a, b) => dayjs.utc(a.estimated_start_date) - dayjs.utc(b.estimated_start_date))
    my_reservations.forEach(reservation => {
        if (dayjs.utc(reservation.estimated_start_date) < reserveEndDate && dayjs.utc(reservation.estimated_end_date) > reserveStartDate && ["RESERVED", "CHECKED_OUT"].includes(reservation.status)) {
            rentalItem.overlapping_reservations.push(reservation)
        }
    });
    if (rentalItem.overlapping_reservations.length > 0) {
        const date_format = 'ddd, D MMM YYYY h:mm A'
        if (rentalItem.bulk_type) {
            rentalItem.reservation_tooltip = `Overlaps with reservations ${rentalItem.overlapping_reservations.map((x) => `${dayjs.utc(x.estimated_start_date).local().format(date_format)}-${dayjs.utc(x.estimated_end_date).local().format(date_format)} (x${x.quantity})`).join(', ')}`
            // calculate max available
            const max_used = max_quantity_used(rentalItem.overlapping_reservations)
            console.log('rendered quantity available')
            rentalItem.max_available = rentalItem.total_quantity - max_used
            rentalItem.available = rentalItem.max_available > 0
        } else {
            rentalItem.reservation_tooltip = `Overlaps with reservations ${rentalItem.overlapping_reservations.map((x) => `${dayjs.utc(x.estimated_start_date).local().format(date_format)}-${dayjs.utc(x.estimated_end_date).local().format(date_format)}`).join(', ')}`
            rentalItem.available = false
        }
    } else {
        rentalItem.max_available = rentalItem.total_quantity ?? 1
        rentalItem.available = true
    }
    return rentalItem
}

export const max_quantity_used = (rental_contract_items) => {
    var overlaps = rental_contract_items.map((reservation) => { return { start: reservation.estimated_start_date, end: reservation.estimated_end_date, quantity: reservation.quantity } })
    overlaps.sort((a, b) => dayjs.utc(a.start) - dayjs.utc(b.start)) // sort
    let i = 0
    // Loop over the reservations finding any overlaps. If there are overlaps, generate new smaller objects combining the quantities
    // After generating new smaller objects, remove the old ones, sort the list, and start over
    while (i < overlaps.length - 1) {
        const r1 = overlaps[i]
        const r2 = overlaps[i + 1]
        // edge case
        if (r1.start === r2.start) {
            if (r1.end === r2.end) {
                overlaps.push({ start: r1.start, end: r1.end, quantity: r1.quantity + r2.quantity }) // combine them into 1
            } else if (dayjs.utc(r2.end) < dayjs.utc(r1.end)) {
                overlaps.push({ start: r1.start, end: r2.end, quantity: r1.quantity + r2.quantity }) // beginning of r1 is r1 and r2 combined
                overlaps.push({ start: r2.end, end: r1.end, quantity: r1.quantity }) // remainder is just leftover r1
            } else {
                overlaps.push({ start: r1.start, end: r1.end, quantity: r1.quantity + r2.quantity }) // beginning of r1 is r1 and r2 combined
                overlaps.push({ start: r1.end, end: r2.end, quantity: r2.quantity }) // remainder is just leftover r2
            }
            overlaps.splice(i, 2) // remove old reservations
            overlaps.sort((a, b) => dayjs.utc(a.start) - dayjs.utc(b.start)) // sort
            i = 0 // start over
        } else if (dayjs.utc(r2.start) < dayjs.utc(r1.end)) { // overlapping
            if (r1.end === r2.end) {
                overlaps.push({ start: r1.start, end: r2.start, quantity: r1.quantity }) // r1 -> r2 just r1
                overlaps.push({ start: r2.start, end: r1.end, quantity: r1.quantity + r2.quantity }) // r2 + r1 -> end
            } else if (dayjs.utc(r2.end) < dayjs.utc(r1.end)) {
                overlaps.push({ start: r1.start, end: r2.start, quantity: r1.quantity }) // r1 -> start of r2
                overlaps.push({ start: r2.start, end: r2.end, quantity: r1.quantity + r2.quantity }) // r1 + r2 -> end of r2
                overlaps.push({ start: r2.end, end: r1.end, quantity: r1.quantity }) // after r2 ends, the rest of r1
            } else {
                overlaps.push({ start: r1.start, end: r2.start, quantity: r1.quantity }) // r1 -> start of r2
                overlaps.push({ start: r2.start, end: r1.end, quantity: r1.quantity + r2.quantity }) // r1 + r2 -> end of r1
                overlaps.push({ start: r1.end, end: r2.end, quantity: r2.quantity })// after r1 ends, the rest of r2
            }
            overlaps.splice(i, 2)
            overlaps.sort((a, b) => dayjs.utc(a.start) - dayjs.utc(b.start)) // sort
            i = 0
        } else {
            i++
        }
    }
    return overlaps.map((x) => x.quantity).reduce((a, b) => Math.max(a, b), 0);
}

export const getDocumentation = (item, item_type) => {
    const url = `/customerfiles/client/${item.client_id}/${item_type}/${item.id}/${item.documentation_path}`
    window.open(url)
}

export const moneyFormat = (num, includeZeros = true) => {
    if (!isFinite(num) || num === '') {
        if (includeZeros) {
            return "-.--"
        } else {
            return "-"
        }
    }
    num = num ?? 0
    var parts = parseFloat(num).toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (parts[1] === '00' && !includeZeros) {
        return parts[0]
    } else {
        return parts.join(".");
    }
}
export const formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        var intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return phoneNumberString;
}

export const widthChangeEvent = (setWindowInnerWidth) => {
    const debouncedHandleResize = debounce(function handleResize() {
        setWindowInnerWidth(window.innerWidth)
    }, 100)

    window.addEventListener('resize', debouncedHandleResize)

    return _ => {
        window.removeEventListener('resize', debouncedHandleResize)
    }
}

export const parseMoneyInput = (original, input, { allow_negative = false, allow_empty = false, precision = 2 } = {}) => {
    if (allow_negative && (input === '-' || input === '0-')) {
        return '-'
    }
    else if (allow_empty && input === '') {
        return input
    }
    else if ((allow_negative && input.match(new RegExp(`^-?\\d*(\\.\\d{0,${precision}})?$`))) || (input.match(new RegExp(`^\\d*(\\.\\d{0,${precision}})?$`)))) {
        if ((allow_negative && input.match(/^-?\d*\.$/)) || (input.match(/^\d*\.$/))) {
            return input
        } else {
            return input
        }
    }
    return original
}

export const formatCustomerName = (customer) => {
    let name = customer.name ?? ''
    if (customer.company_name && name.trim().length === 0) {
        name = customer.company_name
    }
    return name
}

export const formatDuration = (mins) => {
    if (isFinite(mins)) {
        return `${parseInt(mins / 60)}:${mins % 60 < 10 ? '0' : ''}${Math.round(mins % 60)}`
    } else {
        return '-:--'
    }
}

export const formatDurationDays = (hours) => {
    const days = Math.floor(hours / 24)
    const hours_under_24 = hours % 24
    return `${days > 0 ? `${days} days, ` : ''}${hours_under_24} hrs`
}